import { DealerGroup } from "../../../models/Organization/DealerGroup";
import createReducer from "../../utils/createReducer";
import ActionTypes from "./actionTypes";

export type OrgStateT = {
    orgs: DealerGroup[];
    activeOrg?: DealerGroup;
    loadingOrgs: boolean;
    orgsLoaded: boolean;
};

export const initialState: OrgStateT = {
    orgs: [],
    loadingOrgs: false,
    orgsLoaded: false,
    activeOrg: undefined,
};

// App Reducer
export default createReducer<OrgStateT>(initialState, {
    [ActionTypes.SAVE_DEALERGROUPS]: (state, payload: DealerGroup[]) => ({
        ...state,
        orgs: payload,
        orgsLoaded: true,
    }),
    [ActionTypes.LOADING_DEALERGROUPS]: (state, payload: boolean) => ({
        ...state,
        loadingOrgs: payload,
    }),
    [ActionTypes.SET_ACTIVE_DEALERGROUP]: (state, payload: DealerGroup) => ({
        ...state,
        activeOrg: payload,
    }),
    [ActionTypes.LOGOUT_ACTION]: (state) => ({
        ...state,
        ...initialState,
    }),
});
